export default function Cookiepolitik() {
  return (
    <div className="min-h-screen bg-white">
      <div className="mx-auto max-w-4xl px-4 py-16 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-extrabold text-slate-900 mb-8">Cookiepolitik</h1>

        <div className="prose prose-slate max-w-none">
          <p className="text-sm text-slate-600 mb-8">
            <strong>Senest opdateret:</strong> 6. december 2025
          </p>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">Hvad er cookies?</h2>
            <p className="text-slate-700 leading-relaxed">
              Cookies er små tekstfiler, som gemmes på din computer, tablet eller smartphone, når du besøger en hjemmeside.
              De bruges til at hjemmesiden kan huske dine handlinger og præferencer (såsom login, sprog, skriftstørrelse og andre
              visningsindstillinger) over en periode, så du ikke behøver at indtaste dem igen, hver gang du kommer tilbage til siden
              eller browser fra den ene side til den anden.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">Hvordan bruger vi cookies?</h2>
            <p className="text-slate-700 leading-relaxed mb-4">
              plejesoestrene.dk bruger cookies til at:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2">
              <li>Sikre hjemmesidens basale funktionalitet (nødvendige cookies)</li>
              <li>Huske dine cookie-præferencer</li>
              <li>Forbedre brugeroplevelsen ved at analysere hvordan hjemmesiden bruges (kun hvis du har givet samtykke)</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">Typer af cookies vi bruger</h2>

            <h3 className="text-xl font-semibold text-slate-900 mb-3">1. Nødvendige cookies (kræver IKKE samtykke)</h3>
            <p className="text-slate-700 leading-relaxed mb-4">
              Disse cookies er nødvendige for at hjemmesiden kan fungere korrekt. De kan ikke slås fra i vores systemer.
            </p>

            <div className="overflow-x-auto mb-6">
              <table className="min-w-full border border-slate-200">
                <thead className="bg-slate-50">
                  <tr>
                    <th className="border border-slate-200 px-4 py-2 text-left">Cookie navn</th>
                    <th className="border border-slate-200 px-4 py-2 text-left">Formål</th>
                    <th className="border border-slate-200 px-4 py-2 text-left">Varighed</th>
                    <th className="border border-slate-200 px-4 py-2 text-left">Udbyder</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border border-slate-200 px-4 py-2 font-mono text-sm">cookie_consent</td>
                    <td className="border border-slate-200 px-4 py-2">Gemmer dit cookie-samtykke</td>
                    <td className="border border-slate-200 px-4 py-2">12 måneder</td>
                    <td className="border border-slate-200 px-4 py-2">plejesoestrene.dk</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <h3 className="text-xl font-semibold text-slate-900 mb-3">2. Statistik-cookies (kræver samtykke)</h3>
            <p className="text-slate-700 leading-relaxed mb-4">
              Disse cookies hjælper os med at forstå hvordan besøgende interagerer med hjemmesiden. Alle informationer cookies indsamler, er anonyme.
            </p>

            <p className="text-slate-700 leading-relaxed mb-4">
              <strong>Status:</strong> Vi bruger i øjeblikket IKKE statistik-cookies. Hvis vi implementerer dem i fremtiden, vil du blive spurgt om samtykke.
            </p>

            <h3 className="text-xl font-semibold text-slate-900 mb-3">3. Marketing-cookies (kræver samtykke)</h3>
            <p className="text-slate-700 leading-relaxed mb-4">
              Disse cookies bruges til at vise dig relevante annoncer på sociale medier baseret på din aktivitet på vores hjemmeside.
              De aktiveres kun, hvis du har givet dit samtykke.
            </p>

            <div className="overflow-x-auto mb-6">
              <table className="min-w-full border border-slate-200">
                <thead className="bg-slate-50">
                  <tr>
                    <th className="border border-slate-200 px-4 py-2 text-left">Cookie navn</th>
                    <th className="border border-slate-200 px-4 py-2 text-left">Formål</th>
                    <th className="border border-slate-200 px-4 py-2 text-left">Varighed</th>
                    <th className="border border-slate-200 px-4 py-2 text-left">Udbyder</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border border-slate-200 px-4 py-2 font-mono text-sm">_fbp</td>
                    <td className="border border-slate-200 px-4 py-2">Facebook Pixel - sporer besøg for at vise relevante annoncer</td>
                    <td className="border border-slate-200 px-4 py-2">3 måneder</td>
                    <td className="border border-slate-200 px-4 py-2">Meta (Facebook)</td>
                  </tr>
                  <tr>
                    <td className="border border-slate-200 px-4 py-2 font-mono text-sm">_ttp</td>
                    <td className="border border-slate-200 px-4 py-2">TikTok Pixel - sporer besøg for at vise relevante annoncer</td>
                    <td className="border border-slate-200 px-4 py-2">13 måneder</td>
                    <td className="border border-slate-200 px-4 py-2">TikTok</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">Sådan styrer du cookies</h2>

            <h3 className="text-xl font-semibold text-slate-900 mb-3">På vores hjemmeside:</h3>
            <p className="text-slate-700 leading-relaxed mb-4">
              Du kan til enhver tid ændre dine cookie-præferencer ved at klikke på "Cookie-indstillinger" i bunden af siden.
              Her kan du se hvilke cookies der er aktive, og vælge at acceptere eller afvise dem.
            </p>

            <h3 className="text-xl font-semibold text-slate-900 mb-3">I din browser:</h3>
            <p className="text-slate-700 leading-relaxed mb-4">
              Alle moderne browsere giver dig mulighed for at se og slette cookies, samt blokere tredjepartscookies:
            </p>

            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4">
              <li><strong>Chrome:</strong> Indstillinger → Privatliv og sikkerhed → Cookies og andre webstedsdata</li>
              <li><strong>Firefox:</strong> Indstillinger → Privatliv og sikkerhed → Cookies og webstedsdata</li>
              <li><strong>Safari:</strong> Indstillinger → Privatliv → Håndter websitedata</li>
              <li><strong>Edge:</strong> Indstillinger → Cookies og webstedsrettigheder</li>
            </ul>

            <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-4">
              <p className="text-sm text-amber-900">
                <strong>Bemærk:</strong> Hvis du blokerer eller sletter alle cookies, kan nogle funktioner på hjemmesiden ikke virke korrekt.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">Tredjeparter</h2>
            <p className="text-slate-700 leading-relaxed mb-4">
              Nogle cookies kan sættes af tredjeparter, når de leverer tjenester på vores vegne. Disse parter har deres egne privatlivspolitikker:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2">
              <li>
                <strong>Meta (Facebook):</strong> Vi bruger Facebook Pixel til annoncemåling.{" "}
                <a href="https://www.facebook.com/privacy/policy/" target="_blank" rel="noopener noreferrer" className="text-brand-600 hover:underline">
                  Læs Metas privatlivspolitik
                </a>
              </li>
              <li>
                <strong>TikTok:</strong> Vi bruger TikTok Pixel til annoncemåling.{" "}
                <a href="https://www.tiktok.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-brand-600 hover:underline">
                  Læs TikToks privatlivspolitik
                </a>
              </li>
            </ul>
            <p className="text-slate-700 leading-relaxed mt-4">
              Disse tredjeparts-cookies aktiveres kun, hvis du har givet dit samtykke til marketing-cookies.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">Samtykke og tilbagetrækning</h2>
            <p className="text-slate-700 leading-relaxed mb-4">
              Ved første besøg på vores hjemmeside vil du se et cookie-banner, hvor du kan vælge at:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4">
              <li><strong>Acceptere alle cookies</strong> - Giver samtykke til alle cookie-kategorier</li>
              <li><strong>Kun nødvendige cookies</strong> - Kun strengt nødvendige cookies vil blive brugt</li>
              <li><strong>Tilpas indstillinger</strong> - Vælg præcist hvilke cookie-kategorier du ønsker</li>
            </ul>
            <p className="text-slate-700 leading-relaxed">
              Du kan til enhver tid trække dit samtykke tilbage ved at ændre dine cookie-indstillinger.
              Dette vil ikke påvirke lovligheden af behandlingen baseret på samtykke før tilbagetrækning.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">Spørgsmål?</h2>
            <p className="text-slate-700 leading-relaxed mb-4">
              Hvis du har spørgsmål til vores brug af cookies, er du velkommen til at kontakte os:
            </p>
            <p className="text-slate-700 leading-relaxed">
              Email: <a href="mailto:info@plejesoestrene.dk" className="text-brand-600 hover:underline">info@plejesoestrene.dk</a><br />
              Telefon: <a href="tel:+4589801515" className="text-brand-600 hover:underline">89801515</a>
            </p>
            <p className="text-slate-700 leading-relaxed mt-4">
              Læs mere om hvordan vi behandler personoplysninger i vores{" "}
              <a href="/privatlivspolitik" className="text-brand-600 hover:underline">Privatlivspolitik</a>.
            </p>
          </section>

          <div className="mt-12 pt-8 border-t border-slate-200">
            <p className="text-sm text-slate-600">
              Denne cookiepolitik er udarbejdet i overensstemmelse med:
            </p>
            <ul className="list-disc pl-6 text-sm text-slate-600 space-y-1 mt-2">
              <li>Europa-Parlamentets og Rådets forordning (EU) 2016/679 (GDPR)</li>
              <li>Cookiebekendtgørelsen (BEK nr. 1148 af 9. december 2011)</li>
              <li>ePrivacy-direktivet (direktiv 2002/58/EF)</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 text-center">
          <a
            href="/"
            className="btn btn-primary btn-lg"
          >
            Tilbage til hjemmesiden
          </a>
        </div>
      </div>
    </div>
  );
}
